import React, { useEffect, useState } from 'react'
import { Col, Row, Image } from 'react-bootstrap'
import imgSKY from '../../../images/SKY.png'
import imgMettheir from '../../../images/MT.jpg'
import imgAstro from '../../../images/ASTRO.png'
import imgProInside from '../../../images/ProInside.png'
import { getContractDetailAPI } from '../../../services/contract'
import { useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import ContractSecretNav from './contract-nav-secret'
import moment from 'moment'
import Error_500 from '../../error/error-500'

export default function SecretPreview() {
  // const orgId = useSelector((state) => state.roleReducer.role)
  let [searchParams, setSearchParams] = useSearchParams()
  const idCard = searchParams.get('idCard')
  const phone = searchParams.get('phone')
  const orgId = searchParams.get('orgId')
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const [isConfirm2, setIsConfirm2] = useState()
  const [isConfirm3, setIsConfirm3] = useState()
  const [isConfirm4, setIsConfirm4] = useState()
  const [signaturePD, setSignaturePD] = useState([])
  const [signatureCEO, setSignatureCEO] = useState([])
  const [signatureTO, setSignatureTO] = useState([])
  const [signatureEMP, setSignatureEMP] = useState([])
  const [signatureVP, setSignatureVP] = useState([])
  const [isCheck2, setIsCheck2] = useState([])

  useEffect(() => {
    getContractDetail()
    moment.locale('th')
  }, [])

  const getContractDetail = async () => {
    try {
      setIsLoading(true)

      const param = { orgId, idCard, phone }
      const result = await getContractDetailAPI(param)
      setIsLoading(false)

      if (!result) return
      if (result.status) {
        setData(result.result)
        setIsConfirm2(result.result.signatures_pd[1].pd2.is_confirm)
        setIsConfirm3(result.result.signatures_pd[2].pd3.is_confirm)
        setIsConfirm4(result.result.signatures_pd[3].pd4.is_confirm)
        setSignaturePD(result.result.signatures_pd[1].pd2)

        setSignatureCEO(result.result.signatures[0].ceo)
        setSignatureVP(result.result.signatures[2].vp)
        setSignatureTO(result.result.signatures[4].report_to)
        setSignatureEMP(result.result.signatures[5].employee)
        setIsCheck2(result.result.signatures_pd[1].pd2.is_confirm)
      }
    } catch (error) {
      Error_500(error)
    }
  }
  return (
    <>
      {isLoading && <div className="preloader"></div>}

      <ContractSecretNav
        data={data}
        isCheck2={isCheck2}
        signatureVP={signatureVP}
        getContractDetail={getContractDetail}
        signatureEMP={signatureEMP}
        signatureTO={signatureTO}
        signatureCEO={signatureCEO}
      />
      <Row>
        <Col xl={12}>
          <div
            className=" p-2 m-2"
            style={{
              lineHeight: 2
            }}
          >
            <div
              className="d-flex justify-content-start"
              style={{
                height: 80
              }}
            >
              {data?.org_id === 1 ? (
                <Image
                  className="mt-3"
                  style={{
                    width: 100,
                    height: 50
                  }}
                  src={imgSKY}
                />
              ) : data?.org_id === 2 ? (
                <Image
                  className="mt-2"
                  style={{
                    width: 100,
                    height: 80
                  }}
                  src={imgMettheir}
                />
              ) : data?.org_id === 3 ? (
                <Image
                  className="mb-1"
                  style={{
                    width: 90,
                    height: 80
                  }}
                  src={imgAstro}
                />
              ) : data?.org_id === 5 ? (
                <Image
                  className="mt-3"
                  style={{
                    width: 110,
                    height: 55
                  }}
                  src={imgProInside}
                />
              ) : null}
            </div>
            <h5 className="text-center mb-3">
              สัญญาการเก็บรักษาข้อมูลที่เป็นความลับ
            </h5>
            {/* edit-text-right */}
            <p className="fw-light small mb-0 ">ทำที่{'  ' + data?.org_th}</p>
            <p className="fw-light small mt-0">
              วันที่
              {' ' +
                moment(data?.start_date).add(543, 'year').format('D MMMM YYYY')}
            </p>
            <p className="fw-light small ">
              &nbsp; &nbsp; &nbsp; &nbsp;สัญญาฉบับนี้ทำขึ้นระหว่าง{' '}
              {data?.org_th +
                ' ' +
                data?.address1_th +
                ' ' +
                data?.address2_th +
                ' ' +
                `(ซึ่งต่อไปนี้ ในสัญญานี้เรียกว่า "บริษัท)` +
                // " " +
                // data?.fax_no +
                ' '}
              ฝ่ายหนึ่งกับ
              {' ' +
                data?.title_th +
                data?.name_th +
                ' ' +
                data?.surname_th +
                ' '}{' '}
              พนักงานตำแหน่ง
              {data?.position_th} (ซึ่งต่อไปจะเรียกว่า “พนักงาน”) อีกฝ่ายหนึ่ง
            </p>

            <p className="fw-light small mt-0">
              &nbsp; &nbsp; &nbsp;
              &nbsp;คู่สัญญาทั้งสองฝ่ายได้ตกลงกันที่จะทำสัญญาการเก็บรักษาข้อมูลที่เป็นความลับ
              (ซึ่งต่อไปจะเรียกว่า “สัญญา”) ดังนี้
            </p>

            <p className="fw-light small mt-0">
              {' '}
              &nbsp; 1. “ข้อมูลความลับ” หมายถึง ข้อมูลใด ๆ
              ซึ่งบริษัทได้เปิดเผยให้แก่พนักงานตั้งแต่ระยะเวลาที่พนักงานเริ่มเข้าทำงานกับบริษัท
              โดยบริษัทประสงค์ให้พนักงานเก็บรักษาข้อมูลดังกล่าวไว้เป็นความลับ
              ซึ่งข้อมูลความลับดังกล่าว หมายความถึง ข้อมูลและความลับทางการค้า
              ความรู้เกี่ยวกับผลิตภัณฑ์ วิธีใช้ผลิตภัณฑ์
              ข้อมูลและรายละเอียดด้านเทคนิค แผนและกลยุทธ์การดำเนินธุรกิจ
              ข้อมูลการเงินและการตลาด แผนการพัฒนาหรือค้นคว้าวิจัย
              ทั้งในรูปที่จับต้องได้และจับต้องไม่ได้ พร้อมกับการวิเคราะห์ รวบรวม
              การศึกษา เอกสารอื่น ๆ และบรรดาสำเนา บันทึก รายงาน
              ที่มีหรือแสดงโดยประการอื่นใดให้เห็นถึงข้อมูลดังกล่าวและเกี่ยวข้องกับกิจการของบริษัท
              ซึ่งได้จัดเตรียมไว้โดยบริษัทหรือคำแนะนำของบริษัท
              หรือจัดทำโดยบุคคลอื่นที่ได้กระทำในนามของบริษัทที่ได้เปิดเผยให้กับพนักงาน
              ซึ่งพนักงานได้รับทราบข้อมูลไม่ว่าวิธีการใดในทางการงานที่เกี่ยวข้องกับการปฏิบัติงานของพนักงาน
            </p>

            <p className="fw-light small mt-0">
              {' '}
              &nbsp; 2. พนักงานที่มีหน้าที่เกี่ยวข้องกับข้อมูลความลับ
              ความลับทางการค้า ความลับในการดำเนินธุรกิจ ขั้นตอนในการดำเนินธุรกิจ
              รายละเอียดหรือข้อมูลใด ๆ อันเกี่ยวกับบุคคล บัญชี การเงิน
              สินค้า/บริการ รายชื่อและรายละเอียดที่เกี่ยวข้องกับลูกค้าของบริษัท
              รวมถึงความลับในการทำธุรกรรมต่าง ๆ ของบริษัท
              ซึ่งพนักงานได้รับทราบระหว่างปฏิบัติหน้าที่
              พนักงานรับรองและสัญญาว่า
            </p>

            <p className="fw-light small mt-0">
              {' '}
              &nbsp;&nbsp; 2.1. ในระหว่างที่เป็นพนักงานของบริษัท
              และตลอดไปหลังจากนั้น
              พนักงานจะเก็บรักษาข้อมูลดังกล่าวด้วยความรับผิดชอบและเก็บข้อมูลความลับไว้โดยครบถ้วน
              และ เคร่งครัด
            </p>

            <p className="fw-light small mt-0">
              {' '}
              &nbsp;&nbsp; 2.2. จะไม่กระทำการใช้ เอาไป
              หรือเปิดเผยข้อมูลไม่ว่าทั้งหมดหรือบางส่วนให้แก่บุคคลภายนอกที่ไม่มีส่วนเกี่ยวข้องกับการดำเนินธุรกิจของบริษัท
              เว้นแต่บริษัทอนุญาตไว้เป็นลายลักษณ์อักษร
              โดยพนักงานต้องไม่ใช้ข้อมูลความลับดังกล่าวกระทำการให้บริษัทเสียหายไม่ว่าทางตรงหรือทางอ้อม
            </p>

            <p className="fw-light small mt-0">
              {' '}
              &nbsp;&nbsp; 2.3.
              พนักงานจะไม่ใช้ข้อมูลความลับเพื่อประโยชน์ของตนเอง
              หรือของผู้อื่นยิ่งไปกว่าประโยชน์ของบริษัท
            </p>

            <p className="fw-light small mt-0">
              {' '}
              &nbsp; 3. บรรดาข้อมูลความลับทั้งหลาย
              และผลงานของพนักงานที่ได้จากการปฏิบัติงาน
              ทั้งตามหน้าที่รับผิดชอบและตามคำสั่งของผู้บังคับบัญชา
              ถือเป็นทรัพย์สินของบริษัทแต่ผู้เดียว
              พนักงานจะต้องดำเนินการอย่างใดอย่างหนึ่งตามที่บริษัทร้องขอ
              หรือเมื่อพนักงานสิ้นสุดสัญญาการเป็นพนักงานของบริษัท ดังนี้
            </p>

            <p className="fw-light small mt-0">
              {' '}
              &nbsp;&nbsp; 3.1.
              ให้พนักงานส่งบรรดาเอกสารข้อมูลดังกล่าวข้างต้นที่พนักงานได้รับอันเนื่องมาจากการปฏิบัติงานให้แก่บริษัทในทันที
            </p>
            <p className="fw-light small mt-0">
              {' '}
              &nbsp;&nbsp; 3.2. ให้ทำลาย เพื่อเป็นการคุ้มครองตามระเบียบ
              หรือตามที่กฎหมายกำหนด
              และในกรณีที่ข้อมูลความลับถูกเก็บอยู่ในเครื่องคอมพิวเตอร์
              จะต้องทำการลบทิ้งรายการข้อมูลต่าง ๆ ที่มีอยู่
              โดยที่ได้ผ่านการตรวจสอบจากบริษัท
              ซึ่งบริษัทจะต้องเป็นผู้ทำการอนุมัติการลบทิ้งข้อมูลดังกล่าว
            </p>
            <p className="fw-light small mt-0">
              {' '}
              &nbsp; 4. หากพนักงานกระทำผิดหรือกระทำการฝ่าฝืนสัญญานี้ไม่ว่ากรณีใด
              ๆ พนักงานยินยอมให้บริษัทดำเนินคดีฟ้องร้องต่อศาลได้ทันที
              และพนักงานจะต้องชดใช้ค่าเสียหายทั้งหมดให้แก่บริษัท
            </p>
            <p className="fw-light small mt-0">
              {' '}
              &nbsp; 5. ข้อผูกพันในการเก็บความลับตามสัญญาฉบับนี้
              ยังคงมีผลใช้บังคับตลอดระยะเวลาที่เป็นพนักงานของบริษัทและเมื่อสัญญาว่าจ้างพนักงานได้สิ้นสุดลงไม่ว่ากรณีใด
              ๆ ให้สัญญานี้ยังคงมีผลอยู่ต่อไปอีกเป็นเวลา 1
              ปีภายหลังจากพ้นสภาพการเป็นพนักงานของบริษัท
              เว้นแต่จะได้รับความยินยอมล่วงหน้า เป็นลายลักษณ์อักษรจากบริษัท
            </p>
            <p className="fw-light small mt-0">
              {' '}
              &nbsp; 6. พนักงานตกลงว่าจะไม่รับจ้างทำงานกับบุคคลใด
              นิติบุคคลใดที่ประกอบธุรกิจอันเป็นการแข่งขัน กับบริษัทเป็นระยะเวลา
              6 เดือนภายหลังพ้นสภาพการเป็นพนักงานของบริษัท เว้นแต่จะได้รับ
              ความยินยอมล่วงหน้าเป็นลายลักษณ์อักษรจากบริษัท
            </p>
            <p className="fw-light small mt-0">
              {' '}
              &nbsp; 7. ทั้งสองฝ่ายตกลงร่วมกันโดยให้ถือสัญญาฉบับนี้
              เป็นส่วนหนึ่งของสัญญาจ้างงานของพนักงานด้วย
            </p>
            <p className="fw-light small mt-0">
              {' '}
              &nbsp; 8. หากเงื่อนไขหรือข้อตกลงใด ๆ ในสัญญาฉบับนี้ตกเป็นโมฆะ
              ไม่สมบูรณ์หรือขัดต่อกฎหมาย หรือใช้บังคับไม่ได้ไม่ว่าเพราะเหตุใด
              ๆก็ตาม พนักงานยินยอมให้เงื่อนไขหรือข้อตกลงใด ๆ ที่เป็นโมฆะ
              ไม่สมบูรณ์หรือขัดต่อกฎหมาย หรือใช้บังคับไม่ได้นั้น
              แยกออกจากเงื่อนไข หรือข้อตกลงส่วนที่สมบูรณ์และให้เงื่อนไข
              ข้อตกลงในส่วนที่สมบูรณ์มีผลใช้บังคับต่อไป
            </p>
            <p className="fw-light small mt-0">
              &nbsp; &nbsp; &nbsp;
              &nbsp;สัญญาฉบับนี้ทำขึ้นสองฉบับมีข้อความถูกต้องตรงกัน
              คู่สัญญาทั้งสองฝ่ายได้อ่านข้อความตามสัญญาโดยตลอดแล้ว
              เห็นว่าตรงตามเจตนารมณ์ของคู่สัญญาแล้วทุกประการ
              ทั้งสองฝ่ายจึงได้ลงลายมือชื่อไว้เป็นสำคัญต่อหน้าพยาน
            </p>

            {isConfirm2 === 1 && isConfirm3 === 1 && isConfirm4 === 1 ? (
              <div
                className="border-2 p-5 card d-flex justify-content-center align-items-center"
                style={{
                  borderRadius: '5px',
                  border: 'dotted',
                  maxHeight: '300px'
                }}
              >
                {signaturePD && (
                  <div className="col-6">
                    <p className="fw-light text-center small mt-4 ">
                      <span className="m-0 p-0 d-flex justify-content-center">
                        <Image
                          src={signaturePD?.url || null}
                          style={{
                            width: '150px',
                            marginBottom: -25
                          }}
                        ></Image>
                      </span>
                      ลงชื่อ........................................................................
                      ผู้ดำเนินการ
                    </p>
                    <p className="fw-light text-center small mt-0">
                      (
                      {signaturePD.title_th +
                        signaturePD.name_th +
                        ' ' +
                        signaturePD.surname_th}
                      )
                    </p>
                    <p className="fw-light text-center small mt-0 ">
                      {signaturePD.position_th}
                    </p>
                    <p className="fw-light text-center small mt-0">
                      วันที่{' '}
                      {signaturePD.confirm_date_pd
                        ? moment(signaturePD.confirm_date_pd)
                            .add(543, 'year')
                            .format('D MMMM YYYY HH:mm')
                        : '-'}
                    </p>
                  </div>
                )}
              </div>
            ) : (
              <></>
            )}
          </div>
        </Col>
      </Row>
      <Row>
        <Col xl={12} className="">
          <hr />
          <div className="p-3 ">
            <div className="fw-light " style={{ fontSize: 12 }}>
              {data?.org_th} {data?.address1_th} {data?.address2_th} โทรศัพท์:{' '}
              {data?.tel_no} โทรสาร: {data?.fax_no}
            </div>
            <div className=" fw-light " style={{ fontSize: 12 }}>
              {data?.org_en} {data?.address1_en} {data?.address2_en} Telephone:{' '}
              {data?.tel_no} Fax: {data?.fax_no}
            </div>
          </div>
        </Col>
      </Row>
    </>
  )
}
